var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audit-section-description"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"audit-section-description__content"},[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audit-section-description__icon"},[_c('i',{staticClass:"fa-solid fa-circle-info"})])
}]

export { render, staticRenderFns }